import React from 'react';

const SvgRectangleActive = ({
  cx,
  cy,
  color,
  mouseEnter,
  mouseLeave,
  index
}) => (
  <svg
    cx={cx}
    cy={cy}
    x={cx - 9}
    y={cy - 9}
    fill={color}
    width={18}
    height={18}
    onMouseEnter={() => mouseEnter(cx, cy, index)}
    onMouseLeave={() => mouseLeave()}
  >
    <defs>
      <filter
        id="rectangleActive_svg__a"
        width="220%"
        height="220%"
        x="-60%"
        y="-60%"
        filterUnits="objectBoundingBox"
      >
        <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={2}
        />
        <feComposite
          in="shadowBlurOuter1"
          in2="SourceAlpha"
          operator="out"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0.82745098 0 0 0 0 0.337254902 0 0 0 0 0.211764706 0 0 0 0.5 0"
        />
      </filter>
      <path id="rectangleActive_svg__b" d="M260 52h10v10h-10z" />
    </defs>
    <g fill="none" transform="translate(-256 -48)">
      <use
        fill="#000"
        filter="url(#rectangleActive_svg__a)"
        xlinkHref="#rectangleActive_svg__b"
      />
      <path
        fill="#FFF"
        fillRule="evenodd"
        stroke={color}
        strokeLinejoin="square"
        strokeWidth={2}
        d="M261 53h8v8h-8z"
      />
    </g>
  </svg>
);

export default SvgRectangleActive;
